import { motion } from "framer-motion";
import { Sparkles, Globe, Heart, Star } from "lucide-react";

const WORDS = [
  { text: "NEW COUNTRY!", color: "text-white", bg: "bg-[#c92e34]", icon: Globe },
  { text: "NEW PEEPS!", color: "text-[#282829]", bg: "bg-white", icon: Heart },
  { text: "NEW CULTURE!", color: "text-white", bg: "bg-[#282829]", icon: Sparkles },
  { text: "NEW HOME!", color: "text-[#282829]", bg: "bg-white", icon: Star },
];

export default function GenZHook() {
  return (
    <section
      className="relative bg-[#FAFAFA] py-16 md:py-24 overflow-hidden grid-bg border-b-[3px] border-[#282829]"
      data-testid="genz-hook"
    >
      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 text-center">
        {/* Top sticker badge */}
        <motion.div
          initial={{ scale: 0, rotate: 0 }}
          whileInView={{ scale: 1, rotate: -3 }}
          viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 220, damping: 12 }}
          className="inline-flex items-center gap-2 bg-[#282829] text-white px-4 py-1.5 rounded-full border-2 border-[#282829] brutal-shadow-red-sm font-anton text-xs tracking-[0.25em] uppercase"
        >
          <Sparkles size={12} className="text-[#c92e34]" /> Vibe Check · Study Abroad Edition
        </motion.div>

        {/* Headline word stack */}
        <div className="mt-8 space-y-2 md:space-y-3">
          {WORDS.map((w, i) => {
            const Icon = w.icon;
            return (
              <motion.div
                key={w.text}
                initial={{ opacity: 0, x: i % 2 ? 60 : -60, rotate: 0 }}
                whileInView={{ opacity: 1, x: 0, rotate: i % 2 ? 1.2 : -1.2 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ delay: i * 0.1, type: "spring", stiffness: 70, damping: 12 }}
                whileHover={{ scale: 1.02, rotate: i % 2 ? 2 : -2 }}
                className={`inline-flex items-center gap-3 md:gap-5 px-5 md:px-9 py-3 md:py-5 rounded-full border-2 border-[#282829] ${w.bg} ${w.color} ${i % 2 ? "brutal-shadow-ink" : "brutal-shadow-red"}`}
                data-testid={`genz-word-${i}`}
              >
                <span className={`hidden md:grid w-10 h-10 rounded-full place-items-center border-2 border-current ${i % 2 === 0 ? "bg-white text-[#c92e34] border-[#c92e34]" : "bg-[#c92e34] text-white border-white"}`}>
                  <Icon size={18} strokeWidth={2.6} />
                </span>
                <span className="font-display text-3xl sm:text-5xl md:text-6xl lg:text-7xl leading-none tracking-tight">
                  {w.text}
                </span>
              </motion.div>
            );
          })}
        </div>

        {/* CTA tagline */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="mt-10 md:mt-14"
        >
          <h2 className="font-handwritten text-3xl sm:text-4xl md:text-5xl text-[#282829] leading-tight max-w-4xl mx-auto">
            Embark on the <span className="text-[#c92e34]">exciting adventure</span> of studying abroad!
          </h2>
          <p className="mt-5 text-sm md:text-base text-[#282829]/70 max-w-xl mx-auto font-medium">
            Your passport's about to get a glow-up. Pick a destination below 👇
          </p>
        </motion.div>
      </div>
    </section>
  );
}
